import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import { Avatar } from '@douyinfe/semi-ui';
import styles from './style.module.scss';

const Danmaku = ({ data, onEdit }) => {
    const danmakus = data?.danmakus || [{ text: '弹幕文本', avatar: '', textColor: '#fff', fontSize: 18, backgroundColor: 'rgba(0, 0, 0, 0.5)', speed: 10 }];

    return (
        <ModuleBase onEdit={onEdit} style={{ position: 'fixed', top: '20px', left: '0', right: '0', zIndex: 100, backgroundColor: 'transparent', boxShadow: 'none' }}>
            <div className={styles.danmakuContainer}>
                {danmakus.map((item, index) => (
                    <div
                        key={index}
                        className={styles.danmakuItem}
                        style={{
                            animationDelay: `${index * 2}s`,
                            animationDuration: `${item.speed || 10}s`,
                            backgroundColor: item.backgroundColor || 'rgba(0, 0, 0, 0.5)',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            marginBottom: '8px',
                            width: 'fit-content'
                        }}
                    >
                        {item.avatar && (
                            <Avatar
                                src={item.avatar}
                                size="small"
                                style={{ marginRight: '8px' }}
                            />
                        )}
                        <div
                            className={styles.danmakuText}
                            style={{
                                color: item.textColor || '#fff',
                                fontSize: `${item.fontSize || 18}px`
                            }}
                        >
                            {item.text}
                        </div>
                    </div>
                ))}
            </div>
        </ModuleBase>
    );
};

export default Danmaku;